import { Observable } from 'rxjs';

import { SpeedTestMode, SpeedTestSnapshot } from './speed-test.types';

export interface SpeedTestRunner {
  readonly snapshot$: Observable<SpeedTestSnapshot>;
  start(): void | Promise<void>;
  abort(): void;
  dispose(): void;
}

export function selectSpeedTestRunner(
  mode: SpeedTestMode | string,
  live: SpeedTestRunner,
  scenario: SpeedTestRunner,
): SpeedTestRunner {
  return mode === 'scenario' ? scenario : live;
}
